// House blason (crest). White line-art on transparent - invert in light theme.
// Impose ONE dimension only (height OR width); the other stays auto (never distort).
import { IMAGES } from "./images";

export default function Blason({ height, width, className = "" }) {
  const src = IMAGES.crest;
  if (!src) return <span className={`crest-empty ${className}`} aria-hidden="true" />;
  const style = height ? { height, width: "auto" } : width ? { width, height: "auto" } : undefined;
  return <img src={src} alt="Blason LEBOURGEOIS" className={`crest-img ${className}`} style={style} />;
}
